import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface User {
  id: string;
  email: string;
  name: string;
  organizationId?: string;
  groups?: string[];
}

interface AuthState {
  user: User | null;
  token: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isInitializing: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  isInitializing: true,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<{ user: User; token: string; accessToken?: string; refreshToken?: string }>
    ) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.accessToken = action.payload.accessToken ?? null;
      state.refreshToken = action.payload.refreshToken ?? null;
      state.isAuthenticated = true;
      state.isInitializing = false;
      state.isLoading = false;
      state.error = null;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    setInitialized(state) {
      state.isInitializing = false;
    },
    setActiveOrganization(state, action: PayloadAction<string>) {
      if (state.user) {
        state.user.organizationId = action.payload;
      }
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.isInitializing = false;
      state.error = null;
    },
  },
});

export const {
  setCredentials,
  setLoading,
  setError,
  setInitialized,
  setActiveOrganization,
  logout,
} = authSlice.actions;
export const authReducer = authSlice.reducer;
export default authSlice;
